/* eslint-disable max-len */
import React, { useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { PriceHandler } from '../../../redux/helper/CamelCase'
import { AccessPrevilegesFunction } from '../../../constants/globalPrivilegesFunction'

const RecentInvoices = ({setRecentInvoices, recentInvoices, handleViewInvoiceDetails, virtualPaymentModal,setVirtualPaymentModal, handleReturnToRequest}) => {
    const [isEditId, setisEditId] = useState('');

    const privilagesAssigned = AccessPrevilegesFunction('return_order')

    return (
        <div className="sm:px-5 px-3 sm:py-5 py-3 mt-[13px] bg-[#F5F5FA] rounded-lg">
            <div className=" text-start ">
                <p className="sm:text-xs10 text-lg font-semibold text-[#090406]">Your Recent Invoices</p>
            </div>
            <div className="overflow-auto scrollbar-menu dropdown-menu pt-[18px] pb-7 relative z-[6]">
                <table className="w-full table-auto relative">
                    <thead>
                        <tr className="bg-[#555259] h-10">
                            <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[132px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                    Invoice No.
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[156px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    E-waybill No.
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Invoice Date
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[177px] text-center flex justify-center items-center">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Order Category
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[220px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transporter Name
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Order Date
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Shipped from
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Shipped to
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[171px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                    Invoice Value 
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Payment Status
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-2.5 px-7 min-w-[60px]">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {recentInvoices.length > 0 && recentInvoices.map((item, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={`incoice${i}`}>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7  sticky left-0 flex justify-center items-center pt-4" style={{
                                    background: "rgba(255, 255, 255, 0.45)",
                                    backdropFilter: "blur(5.5px)"
                                }}>
                                    {item?.TRX_NUMBER}

                                </td>
                                {item?.WAYBILL_NUMBER === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    :<td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        {item?.WAYBILL_NUMBER}                       
                                    </td>  }   
                                <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                    {moment(item?.INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss')}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.ORDER_CATEGORY}

                                </td>
                                <td className="text-sm font-normal py-2.5 px-7 text-center">
                                    {item?.TRANSPORTER_NAME}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.INDENT_NUMBER}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {moment(item?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss')}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.SHIP_FROM}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.SHIP_TO}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                    {PriceHandler(item?.INVOICE_VALUE)}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.PAYMENT_STATUS}

                                </td>
                                <td 
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                    className="py-2.5 px-7 sticky right-0 bg-[#ffffffe6] z-[1]" style={{
                                        background: "rgba(255, 255, 255, 0.45)",
                                        backdropFilter: "blur(5.5px)"
                                    }}>
                                    <div className="dropdown relative">
                                        <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer"/>
                                        </button>
                                        {isEditId !== '' && (
                                            <ul className={`dropdown-menu min-w-max absolute ${isEditId === i ? 'show' : 'hidden'} top-0 right-12 bg-[#FFFFFF] rounded-[10px] shadow-s2`} aria-labelledby="dropdownMenuButton111">
                                                <li className="px-5 pb-1.5 pt-5" data-bs-toggle="modal" data-bs-target="#view-and-download">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"  
                                                        onClick={() => handleViewInvoiceDetails(item.INVOICE_NO)}
                                                        href="#">View and Download</a>
                                                </li>
                                                {(!item?.PAYMENT_STATUS?.includes('RETURN')  && privilagesAssigned) && <li className="px-5 pt-1.5 pb-1.5">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" 
                                                        href="#" 
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#Return-Order-Request"
                                                        onClick={() => handleReturnToRequest(item)}
                                                    >Request to Return</a>
                                                </li>}
                                                <li className="px-5 pt-1.5 pb-1.5" data-bs-toggle="modal" data-bs-target="#deactivateUserModal">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" 
                                                        href="#"
                                                        onClick={() => setVirtualPaymentModal(true)}
                                                    >Pay</a>
                                                </li> 
                                            </ul>
                                        )}                                      
                                    </div>
                                </td>
                            </tr>
                        ))}       
                    </tbody>
                </table>
            </div>
            <div className="w-full bg-white rounded-[8px] flex justify-center mt-3 shadow-7s">
                <Link to={"/invoices"}>
                    <button className="text-sm55 py-5 text-center  font-normal text-black">View All</button> 
                </Link>
            </div>
        </div>
    )
}

export default RecentInvoices
